import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { InputCP } from 'submodules/nerit-framework-ui/common/components/form-fields/input/InputCP'
import { IconICP } from 'submodules/nerit-framework-ui/common/components/icon/inner/IconICP'
import { FlexCP } from 'submodules/nerit-framework-ui/common/components/flex/FlexCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { RecoverAccessFormModel } from 'app/components/form-login/form-model/RecoverAccessFormModel'
import { RecoverAccessRequestDTO } from 'submodules/nerit-aquatec-sdk/services/auth/dtos/requests/RecoverAccessRequestDTO'
import { AuthRequests } from 'submodules/nerit-aquatec-sdk/services/auth/AuthRequests'

interface ICPProps {
	formStateManager: IFormStateManager<RecoverAccessFormModel>
	onBack: () => void
}

export function FormRecoverAccessICP(props: ICPProps): JSX.Element {

	const recoverAccessRequest = useRequest<void>('none')
	const [isSuccess, setIsSuccess] = useState(false)
	const [hasError, setHasError] = useState(false)

	useEffect(onRecoverAccessRequestChange, [recoverAccessRequest.isAwaiting])

	async function recoverAccess(): Promise<void> {

		props.formStateManager.setConsiderAllErrors(true)

		if (!await props.formStateManager.validate())
			return

		setHasError(false)

		const formValues = props.formStateManager.getFormValues()!

		const dto: RecoverAccessRequestDTO = {
			email: formValues.email,
		}

		recoverAccessRequest.runRequest(
			AuthRequests.recoverAccess(dto)
		)
	}

	function onRecoverAccessRequestChange(): void {

		if (!RequestUtils.isRequestConcluded(recoverAccessRequest))
			return

		if (RequestUtils.isRequestSuccess(recoverAccessRequest, true)) {
			setIsSuccess(true)
			setHasError(false)
			return
		}

		if (RequestUtils.isRequestError(recoverAccessRequest, true)) {
			setHasError(true)
		}

	}

	if (isSuccess) {
		return (
			<>
				<FeedbackSCP>
					Se o e-mail informado estiver cadastrado, as informações
					de acesso serão enviadas para ele.
				</FeedbackSCP>

				<FlexCP
					justifyContent={'flex-end'}
					margin={{ top: 20 }}
				>
					<ButtonCP
						type={'primary'}
						onClick={props.onBack}
					>
						Voltar para o login
					</ButtonCP>
				</FlexCP>
			</>
		)
	}

	return (
		<>
			<DescriptionSCP>
				Informe o e-mail cadastrado para recuperar suas informações de acesso.
			</DescriptionSCP>

			{
				hasError &&
				<ErrorSCP>
					Não foi possível concluir a solicitação. Tente novamente.
				</ErrorSCP>
			}

			<InputCP
				label={'E-mail'}
				fieldName={'email'}
				formStateManager={props.formStateManager}
				required={true}
				icon={<IconICP iconName={'user'}/>}
				onFormSubmit={recoverAccess}
			/>

			<ActionsSCP>
				<BackButtonSCP
					type={'button'}
					onClick={props.onBack}
				>
					Voltar
				</BackButtonSCP>

				<ButtonCP
					type={'primary'}
					onClick={recoverAccess}
					loading={recoverAccessRequest.isAwaiting}
				>
					Recuperar acesso
				</ButtonCP>
			</ActionsSCP>
		</>
	)
}

const DescriptionSCP = styled.p`
	margin-bottom: 20px;
	color: #444444;
	line-height: 1.5;
`

const FeedbackSCP = styled.div`
	padding: 15px;
	border-radius: 5px;
	background: #f5f5f5;
	line-height: 1.5;
`

const ErrorSCP = styled.div`
	margin-bottom: 15px;
	line-height: 1.5;
`

const ActionsSCP = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 20px;
`

const BackButtonSCP = styled.button`
	border: none;
	background: transparent;
	cursor: pointer;
	text-decoration: underline;
`